/******************************************************************************
* File Name: UploadMultiformat.js
* Author   : Mukesh Kumar Basrani
* Summary  : Uploading File to firebase storage related code
* Created  : 05-May-2025
* Modified : 
******************************************************************************/
import React, { useState } from 'react';
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { httpsCallable, getFunctions } from "firebase/functions";
import { useUserContext } from "../App";

const UploadMulti = () => {
  const {
    uploadSuccess,
    setUploadSuccess,
    setProcessSuccess,
    processSuccess,
    setProcessedFileUrl,
    user,
    cgTermsAccepted,
  } = useUserContext();

  const [files, setFiles] = useState({
    icici: null,
    zerd: null,
    format3: null,
  });

  const [isProcessing, setIsProcessing] = useState(false);

  const handleFileChange = (platform) => (event) => {
    setFiles(prev => ({ ...prev, [platform]: event.target.files[0] }));
  };

  const handleUpload = (event) => {
    event.preventDefault();
    if (!cgTermsAccepted) {
      alert('Accept the CG Terms and conditions to proceed.');
      return;
    }

    const storage = getStorage();
    const storageRef = ref(storage);
    const uploads = {};
    const uploadPromises = [];
    
    Object.entries(files).forEach(([platform, file]) => {
      if (file) {
        const extension = file.name.split('.').pop();
        const filePath = `uploads/${user.uid}_${platform}.${extension}`;
        const fileRef = ref(storageRef, filePath);
        uploads[platform] = filePath;
        console.error('file 53',file);
        const uploadPromise = uploadBytes(fileRef, file);
        uploadPromises.push(uploadPromise);
      }
    });

    if (uploadPromises.length === 0) {
      alert('Please select at least one file to upload.');
      return;
    }

    Promise.all(uploadPromises)
      .then(() => {
        console.log('All files uploaded successfully');
        setUploadSuccess(true);
        localStorage.setItem('uploadedFiles', JSON.stringify(uploads));
      })
      .catch((error) => {
        console.error('Error uploading files:', error);
        alert('File upload failed.');
      });
  };

  const handleProcess = () => {
    if (!cgTermsAccepted) {
      alert('Accept the CG Terms and conditions to proceed.');
      return;
    }

    if (isProcessing) return;

    setIsProcessing(true);

    const functions = getFunctions();
    const processFileGenV2 = httpsCallable(functions, 'processFileGenV2');

    const uploadedFiles = JSON.parse(localStorage.getItem('uploadedFiles') || '{}');
    const storage = getStorage();
    const payload = {
      bucketName: storage._bucket.bucket,
      userId: user.uid,
      files: uploadedFiles,
    };
    console.error('uploadedFiles',uploadedFiles);
    processFileGenV2(payload)
      .then((result) => {
        if (result.data.success === true) {
          setProcessSuccess(true);
          setProcessedFileUrl(result.data.download_link);
        } else {
          alert('Failed to process files.');
        }
      })
      .catch((error) => {
        console.error('Error processing files:', error);
        alert('An error occurred while processing the files.');
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  const customButtonStyle = {
  display: 'inline-block',
  marginTop: '10px',
  padding: '10px 20px',
  backgroundColor: '#02fabc',
  color: '#043fc9',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '35px',
  lineHeight: '2',
  textAlign: 'center'
};
const submitButtonStyle = {
  ...customButtonStyle,
  backgroundColor: '#02fabc',
  marginTop: '10px',
  justifyContent: 'center'
};
  return (
    <div>
      {!uploadSuccess ? (      
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <form onSubmit={handleUpload} >
          <div>
            <label htmlFor="icici-upload" style={customButtonStyle}>
                Choose  
                <img
                alt="ICICI_logo"
                src={
                  require("../assets/img/icons/common/ICICI_logo.svg")
                  .default
                }
                style={{ height: '40px',marginLeft: '20px', marginRight: '20px', objectFit: 'contain' }}
              /> 
               here
            </label>
            <input id="icici-upload" type="file" accept=".csv" 
               style={{ display: 'none' }}
                onChange={handleFileChange('icici')} />
          </div>
          
          <div>
            <label htmlFor="zerd-upload" style={customButtonStyle}>
                Choose  
                <img
                alt="Zerodha_logo"
                src={require("../assets/img/icons/common/download.svg")
                     .default
                    }
                style={{ height: '40px',marginLeft: '20px', marginRight: '20px', objectFit: 'contain' }}
              /> 
               here 
            </label>                   
            <input id ="zerd-upload" type="file" accept=".xls,.xlsx"        
             style={{ display: 'none' }}  
             onChange={handleFileChange('zerd')} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center'}}>
            <button type="submit" style={submitButtonStyle} disabled={uploadSuccess}> Upload </button>
          </div>
          </form>
        </div>
      ) : (
        <div>
          <h1>Process Uploaded Files</h1>
          <button onClick={handleProcess} disabled={processSuccess || isProcessing}>
            {isProcessing ? 'Processing...' : 'Process'}
          </button>
        </div>
      )}
    </div>
  );
  


};

export default UploadMulti;



